import { getData, postData } from './common.service';

// Kept for any remaining region-keyed Target records; new
// per-employee-within-territory records use getTargetForMe instead.
export async function getTargetByRegion(regionId: string, month: string, year: string) {
    const qs = {
      where: {
        region: regionId,
        month: month,
        year: year
      }
    }
    const url = `/targets?filter=${JSON.stringify(qs)}`;

    return getData(url, {
      sendTokenInHeader: true,
      basePath: process.env.REACT_APP_CORE_API_BASEPATH,
    }).then(res => res.json());
  }

export async function getTargetForMe(territoryId: string, farmUserId: string, month: string, year: string) {
    const qs = {
      where: { and: [{ territoryId }, { farmUserId }, { month }, { year }] },
    };
    const url = `/targets?filter=${JSON.stringify(qs)}`;

    return getData(url, {
      sendTokenInHeader: true,
      basePath: process.env.REACT_APP_CORE_API_BASEPATH,
    }).then(res => res.json());
  }

export async function createTarget(payload: any) {
    return postData('/targets', {
      sendTokenInHeader: true,
      basePath: process.env.REACT_APP_CORE_API_BASEPATH,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: payload,
    });
  }

  export async function updateTarget(id: string, payload: any) {
    const url = `/targets/${id}`;

    return postData(url, {
      sendTokenInHeader:true,
      basePath: process.env.REACT_APP_CORE_API_BASEPATH,
      usePatchMethod: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: payload,
    });
  }
